



























import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

import {
  SystemMessageType,
} from '@/enums/system-messages';


@Component({
  name: 'system-message',
})
export default class SystemMessage extends Vue {
  @Prop({ type: String, default: SystemMessageType.info })
  type?: string;

  @Prop(String)
  title?: string;

  @Prop(String)
  message!: string;

  @Prop(Boolean)
  showReloadButton?: boolean;
}
